import { render, staticRenderFns } from "./ButtonNormal.vue?vue&type=template&id=81a32a56"
import script from "./ButtonNormal.vue?vue&type=script&lang=js"
export * from "./ButtonNormal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports